
import { useState } from 'react';
import { ShoppingCart, ChevronDown } from "lucide-react";
import CartWithWhatsApp from './CartWithWhatsApp';
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
export function Cart({thecart,changeCart})
{
 const { t } = useTranslation();
  function delFromCart(name){
  const temp = [...thecart]
  temp.shift();
  const newList = temp.filter(item=>item.name!==name)
  const total = newList.reduce((sum , item)=> sum+item.Price*item.quantity,0)
  localStorage.setItem("cart",JSON.stringify([{total}, ...newList]))
  changeCart([{total}, ...newList]);
  toast.error(t("item_removed"))
}    
function delAll(){
    changeCart([{total:0}])
    localStorage.removeItem("cart");
    toast.error(t("cart_cleared"))
}
    const total = thecart[0].total;  
    const cartToDisplay = [...thecart];
    cartToDisplay.shift();
    const [open, setOpen] = useState(false);
    const [endRes,setEndRes] = useState(false);
    
   return (
  <>
    {!endRes ? (
    <div className="fixed top-4 right-4 z-[1000]" dir="rtl">
      {!open && (
      <button
        onClick={() => setOpen(true)}
        className="btn btn-primary position-fixed bottom-0 end-0 m-3">
        <ShoppingCart className="h-5 w-5" />
        <span className="text-sm "> {t("view_cart")}</span>
      </button>
      )}


  {open && (
  <div className="w-[300px] rounded-2xl border bg-white/95 shadow-2xl p-4">
  <div className="flex items-center justify-between mb-3">
  <h3 className="font-semibold text-center">{t("shopping_cart")} </h3>
  <button
  onClick={() => setOpen(false)}
  className="flex items-center gap-1 text-sm border rounded-full px-2 py-1 hover:bg-neutral-50">
  <ChevronDown className="h-4 w-4" /> {t("minimize")}
  </button>
  </div>
  <div className="text-sm text-neutral-600">
  <div className="container mt-4">
        <h4 className="mb-3 text-center">{t("your_cart")}</h4>

        <div className="table-responsive shadow-sm">
          <table className="table table-striped align-middle text-center">
            <thead className="table-dark">
              <tr>
                <th>{t("name")}</th>
                <th>{t("price")}</th>
                <th>{t("quantity")}</th>
                <th>{t("total_f_d")} </th>
                  <th></th>
              </tr>
            </thead>
            <tbody>
              {thecart.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-muted">
                    {t("cart_empty")} 
                  </td>
                </tr>
              ) : (
                cartToDisplay.map((p, idx) => (
                  
                  <tr key={idx}>
                    <td>{p[t("name_for_choose")]}</td>
                    <td>${p.Price?.toFixed(2)}</td>
                    <td>{p.quantity}</td>
                    <td>${(p.Price * p.quantity).toFixed(2)}</td>
                    <td><button className='btn btn-danger' onClick={()=>delFromCart(p.name)}>{t("dell")}</button></td>
                  </tr>
                ))
              )}
            </tbody>
            {thecart.length > 0 && (
              <tfoot>
                <tr className="table-secondary fw-bold">
                  <td colSpan="3" className="text-end">
                   {t("total")}
                  </td>
                  <td>${total.toFixed(2)}</td>
                  {cartToDisplay.length!==0?<td><button className='btn btn-danger' onClick={delAll}>{t("reset_cart")}</button></td>:null}
                </tr>
              </tfoot>
            )}
            
          </table>
          <button className='btn btn-primary'onClick={()=>{setEndRes(true)}}>{t("checkout_here")}</button>
        </div>
      </div>
  </div>
  </div>
  )}
    </div>
    ): <CartWithWhatsApp items={[...thecart]} ownerPhone="13476154450" dell={delAll}></CartWithWhatsApp>}
  </>
); 
}
